import React from "react"
import { ReactFC } from "types"
import { Post } from "posts/posts.types"

import styled from "styled-components"
import { eventControlsMargin, } from "./styles"
import { videoIndex } from "pages/profile/posts/view/content/ContentCard"
import Embed from "components/Embed"
import Image from 'components/Image'
import { isNsContent } from "lib-core"

const ImageStyled = styled.div`
  margin: 0 ${eventControlsMargin}px;
`

export const EventImage: ReactFC<{ post: Post }> = ({ post }) => {

  if (!post?.event) {
    return null
  }

  if (isNsContent(post.content)) {
    return null
  }

  const index = videoIndex(post.content as any)
  if (index !== -1) {
    const data = post.content[index].content[0].props.data
    return <Embed data={data} />
  }

  return (
    <ImageStyled>
      <Image data={post.image} />
    </ImageStyled>
  )

}
